import { UploadLettersModalComponent } from '../upload-letters-modal/upload-letters-modal.component';
import { PromissoryNoteComponent } from '../promissory-note/promissory-note.component';
import { DcnAdditionalDataComponent } from '../dcn-additional-data/dcn-additional-data.component';
import { McfAdditionalDataComponent } from '../mcf-additional-data/mcf-additional-data.component';
import {
  DateAdditionalDataComponent
} from '../../../shared/date-additional-data/date-additional-data.component';
import { IssuerConfirmationToIPAComponent } from '../issuer_confirmation_to_IPA/issuer_confirmation_to_IPA.component';


export const signing_states_map = {
  ONLY_UNSIGNED_UPLOAD: 'only_unsigned_upload',
  UNSIGNED: 'unsigned',
  SENT_SIGNING: 'sent_for_signing',
  SIGNED: 'signed'
};

export const issuer_supplimentary_docs_map = {
  init: true,
  generate_isin: false,
  generate_and_sign_post_auction_docs: true,
  send_post_auction_docs_to_investor: true,
  wait_for_investor_to_verify_and_sign_docs: true,
  generate_and_sign_IPA_certificate_creation_docs: true,
  send_IPA_creation_docs_to_IPA: true,
  wait_for_IPA_certificate: true,
  notify_admin: true,
  send_IPA_certificate_to_investor: true,
  generate_and_sign_CAF: true,
  wait_ipa_cp_allotment_letter: true,
  send_CAF_to_RTA_and_NSDL: true,
  wait_to_receive_funds: true,
  wait_for_investor_to_approve_IPA_certificate: true
};

export const issuer_documentation_state_message = {
  init: 'init',
  generate_isin: 'Please review Master Creation Form, select signatories and send for signing.',
  generate_and_sign_post_auction_docs: {
    is_ui_state: true,
    [signing_states_map.UNSIGNED]: `Add additional data for the documents below.
    Generate, Review and proceed to sign the documents.`,
    [signing_states_map.SENT_SIGNING]: `Waiting for the signatories to sign the documents.
    You will be notified once the signing is done.`,
    [signing_states_map.ONLY_UNSIGNED_UPLOAD]: 'Waiting for you to upload the remaining signed document(s).'
  },
  send_post_auction_docs_to_investor: `Waiting for the signatories to sign the documents.
   You will be notified once the signing is done.`,
  wait_for_investor_to_verify_and_sign_docs: 'Waiting for investor(s) to verify and sign the documents.',
  generate_and_sign_IPA_certificate_creation_docs: {
    is_ui_state: true,
    [signing_states_map.UNSIGNED]:
      `Add additional data, Generate and review the documents. Then, proceed to sign below.`,
    [signing_states_map.SENT_SIGNING]: `Waiting for the signatories to sign the documents.
    You will be notified once the signing is done.`,
    [signing_states_map.ONLY_UNSIGNED_UPLOAD]: `Waiting for you to upload the remaining signed document(s).`
  },
  send_IPA_creation_docs_to_IPA: 'Waiting for Signatories to sign the documents.',
  wait_for_IPA_certificate: 'Waiting for IPA to verify and process the documents.',
  notify_admin: 'notify_admin',
  send_IPA_certificate_to_investor: 'Please review and send the IPA certificate to investor.',
  generate_and_sign_CAF: {
    is_ui_state: true,
    [signing_states_map.UNSIGNED]:
      'Please review CAF and CAF Issuance Letter, Select Signatories and proceed to sign the documents.',
    [signing_states_map.SENT_SIGNING]: `Waiting for the signatories to sign the documents.
    You will be notified once the signing is done.`,
    [signing_states_map.ONLY_UNSIGNED_UPLOAD]: 'Waiting for you to upload the remaining signed document(s).',
    [signing_states_map.SIGNED]: 'Waiting for CP Allotment Letter from IPA.'
  },
  wait_ipa_cp_allotment_letter: 'Waiting for CP Allotment Letter from IPA.',
  send_CAF_to_RTA_and_NSDL: 'Waiting for Signatories to sign the Corporate Action Form.',
  wait_to_receive_funds:
    'Deal closed. Send the Corporate Action Form to RTA and NSDL. Ignore if already sent.',
  wait_for_investor_to_approve_IPA_certificate: 'Waiting for Investor(s) to approve IPA Certificate.'
};

export const additional_data_with_docs = {
  promissory_note: {
    title: 'Proof of Stamp Duty Payment',
    data_field: 'stamp_paper_doc'
  },
  eligibility_letter: {
    title: 'Additional Attachment (EL)',
    data_field: 'additional_doc'
  },
  covering_letter: {
    title: 'Additional Attachment (CL)',
    data_field: 'additional_doc'
  }
};

export const issuer_supplimentary_docs_message = {
  init: 'init',
  generate_isin: 'generate_isin',
  generate_and_sign_post_auction_docs: 'Other documents:',
  send_post_auction_docs_to_investor: 'Other documents to be sent to investor after signing:',
  wait_for_investor_to_verify_and_sign_docs: 'Other documents sent to investor:',
  generate_and_sign_IPA_certificate_creation_docs: 'Other documents to be sent to IPA:',
  send_IPA_creation_docs_to_IPA: 'Other documents to be sent to IPA after signing:',
  wait_for_IPA_certificate: 'Other documents sent to IPA:',
  notify_admin: 'notify_admin',
  send_IPA_certificate_to_investor: 'Other documents:',
  generate_and_sign_CAF: 'Other documents:',
  wait_ipa_cp_allotment_letter: 'Other documents sent to IPA:',
  send_CAF_to_RTA_and_NSDL: 'View other documents below:',
  wait_to_receive_funds: 'Other documents:',
  wait_for_investor_to_approve_IPA_certificate: 'Other documents:'
};

export const additional_data_stage_map = {
  master_creation_form: McfAdditionalDataComponent,
  deal_confirmation_note: DcnAdditionalDataComponent,
  letter_of_offer: DateAdditionalDataComponent,
  // letter_of_offer: IssuerConfirmationToIPAComponent,
  promissory_note: PromissoryNoteComponent,
  issuer_confirmation_to_IPA: IssuerConfirmationToIPAComponent,
  covering_letter: UploadLettersModalComponent,
  rbi_letter: DateAdditionalDataComponent,
  eligibility_letter: UploadLettersModalComponent,
  CAF: DateAdditionalDataComponent,
  caf_issuance_letter: DateAdditionalDataComponent,
  cp_allotment: DateAdditionalDataComponent,
  ipa_certificate: DateAdditionalDataComponent,
  CAF_CDSL: DateAdditionalDataComponent,
  caf_cdsl_issuance_letter: DateAdditionalDataComponent
};

export const select_signatories_stage_map = {
  master_creation_form: true,
  letter_of_offer: true,
  deal_confirmation_note: true,
  promissory_note: false,
  issuer_confirmation_to_IPA: true,
  rbi_letter: true,
  covering_letter: true,
  eligibility_letter: true,
  CAF: true,
  cp_allotment: true,
  ipa_certificate: true
};

export const upload_signed_docs_stage_map = {
  master_creation_form: true,
  letter_of_offer: true,
  deal_confirmation_note: true,
  promissory_note: false,
  issuer_confirmation_to_IPA: true,
  rbi_letter: true,
  covering_letter: true,
  eligibility_letter: true,
  CAF: true,
  cp_allotment: true,
  ipa_certificate: true
};

export const optional_additional_data = {
  // covering_letter: false,
  // eligibility_letter: false
};

export const issuer_action_awaited = {
  init: '---',
  generate_isin: 'Generate ISIN',
  generate_and_sign_post_auction_docs: {
    is_ui_state: true,
    [signing_states_map.UNSIGNED]: 'Signing the documents.',
    [signing_states_map.SENT_SIGNING]: 'Waiting for Signatories',
    [signing_states_map.ONLY_UNSIGNED_UPLOAD]: 'Uploading Signed document(s)'
  },
  send_post_auction_docs_to_investor: 'Waiting for Signatories.',
  wait_for_investor_to_verify_and_sign_docs: 'Waiting For Investor(s)',
  generate_and_sign_IPA_certificate_creation_docs: {
    is_ui_state: true,
    [signing_states_map.UNSIGNED]: 'Signing the documents.',
    [signing_states_map.SENT_SIGNING]: 'Waiting for Signatories',
    [signing_states_map.ONLY_UNSIGNED_UPLOAD]: 'Uploading Signed document(s)'
  },
  send_IPA_creation_docs_to_IPA: 'Send Docs To IPA',
  wait_for_IPA_certificate: 'Waiting For IPA',
  notify_admin: '---',
  send_IPA_certificate_to_investor: 'Send IPA To Investor',
  generate_and_sign_CAF: {
    is_ui_state: true,
    [signing_states_map.UNSIGNED]: 'Signing the documents.',
    [signing_states_map.SENT_SIGNING]: 'Waiting for Signatories',
    [signing_states_map.ONLY_UNSIGNED_UPLOAD]: 'Uploading Signed document(s)',
    [signing_states_map.SIGNED]: 'Waiting For IPA'
  },
  wait_ipa_cp_allotment_letter: 'Waiting For IPA',
  send_CAF_to_RTA_and_NSDL: 'Waiting for Signatories.',
  wait_to_receive_funds: 'Deal Closed',
  wait_for_investor_to_approve_IPA_certificate: 'Waiting For Investor(s) To Approve IPA'
};

export const issuer_state_map = {
  init: '---',
  generate_isin: 'First Quote Closed',
  generate_and_sign_post_auction_docs: 'Issue Created',
  send_post_auction_docs_to_investor: 'Issue Created',
  wait_for_investor_to_verify_and_sign_docs: 'Issue Created',
  generate_and_sign_IPA_certificate_creation_docs: 'Issue Created',
  send_IPA_creation_docs_to_IPA: 'Issue Created',
  wait_for_IPA_certificate: 'Issue Created',
  notify_admin: '---',
  send_IPA_certificate_to_investor: 'IPA Generated',
  generate_and_sign_CAF: 'IPA Generated',
  wait_ipa_cp_allotment_letter: 'IPA Generated',
  send_CAF_to_RTA_and_NSDL: 'IPA Generated',
  wait_to_receive_funds: 'Deal Closed',
  wait_for_investor_to_approve_IPA_certificate: 'IPA Generated'
};

export const investor_action_awaited = {
  wait_for_post_auction_docs: 'Waiting For Deal Confirmation Note',
  init: '---',
  wait_to_receive_securties: 'Waiting For Securities',
  verify_IPA_certificate: 'Approve IPA Certificate',
  wait_for_IPA_certificate: 'Waiting For IPA',
  verify_post_auction_docs: {
    is_ui_state: true,
    [signing_states_map.UNSIGNED]: 'Signing the documents.',
    [signing_states_map.SENT_SIGNING]: 'Waiting For Signatories.',
    [signing_states_map.SIGNED]: 'Waiting For IPA',
  }
};

export const investor_supplimentary_docs_message = {
  init: 'init',
  wait_for_post_auction_docs: 'Other documents sent by issuer:',
  verify_IPA_certificate: 'Other documents:',
  wait_for_IPA_certificate: 'Other documents:',
  verify_post_auction_docs: 'Other documents sent by issuer:',
  wait_to_receive_securties: 'Other documents:'
};

export const investor_state_message = {
  init: 'init',
  wait_for_post_auction_docs: '',
  verify_IPA_certificate: 'Please review and approve IPA certificate.',
  wait_for_IPA_certificate: null,
  verify_post_auction_docs: {
    is_ui_state: true,
    [signing_states_map.UNSIGNED]:
      'Please review the Deal Confirmation Note and proceed to sign the below documents.',
    [signing_states_map.SENT_SIGNING]: `Waiting for the signatories to sign the documents.
     You will be notified once the signing is done.`,
    [signing_states_map.SIGNED]: `Waiting for IPA.`
  },
  wait_to_receive_securties: null
};

export const investor_state_map = {
  wait_for_post_auction_docs: 'Bidding Closed',
  init: '---',
  wait_to_receive_securties: 'IPA Approved',
  verify_IPA_certificate: 'IPA Generated',
  wait_for_IPA_certificate: 'Issue Created',
  verify_post_auction_docs: 'Issue Created'
};

// Get the Board Resolution, Signatories list and Credit Rating Letters of the corporate for the cp.
export function parseCorpDocs(corpDocs) {
  const parsedCorpDocs = [];

  if (corpDocs.BoardResolutionCP_board_resolution) {
    parsedCorpDocs.push({
      linkName: 'Board Resolution',
      documentDetails: [{
        title: 'Board Resolution',
        document_url: corpDocs.BoardResolutionCP_board_resolution
      }]
    });
  }

  if (corpDocs.docdata_signatories_doc_location) {
    parsedCorpDocs.push({
      linkName: 'Authorised Signatories List',
      documentDetails: [{
        title: 'Authorised Signatories List',
        document_url: corpDocs.docdata_signatories_doc_location
      }]
    });
  }

  if (corpDocs.issueCreditRatingDetails && corpDocs.issueCreditRatingDetails.length) {
    parsedCorpDocs.push({
      linkName: 'Credit Rating Letters',
      documentDetails: corpDocs.issueCreditRatingDetails.map(letter => {
        return {
          title: 'Credit Rating Letter',
          additionalData: `${letter.name_of_credit_rating_agency} ${letter.credit_rating}`,
          document_url: letter.credit_rating_document
        };
      })
    });
  }

  return parsedCorpDocs;
}
